import type { SoremonMood } from "./soremonStore";

/**
 * 状態ごとの短い一言（体験仕様「5. 会話人格」「15. 基本状態」）。
 * 話しすぎず、仕事を止めない長さにする。
 */
export const soremonMoodText = (mood: SoremonMood, label = ""): string => {
  switch (mood) {
    case "thinking":
      return label ? `${label}…` : "見てみますね…";
    case "acting":
      return label ? `${label}しています…` : "やってみますね…";
    case "asking":
      return "ここだけ確認していい？";
    case "completed":
      return "できました。";
    case "error":
      return "ここで止まりました。";
    default:
      return "";
  }
};
